var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.outer},[_c('div',{ref:"wrapper",class:_vm.$style.wrapper,style:(_vm.filtersStyle)},[_c('div',{class:[_vm.styleGrid.container, _vm.$style.container]},[_c('ul',{class:_vm.$style.ul},_vm._l((_vm.itemsRender),function(item,i){
var _obj;
return _c('li',{key:i,class:_vm.$style.li},[_c('a',{class:[
              _vm.$style.link,
              ( _obj = {}, _obj[_vm.$style.active] = _vm.activeBlock === item.code, _obj ) ],on:{"click":function($event){return _vm.goTo(item.code)}}},[_vm._v(_vm._s(item.title))])])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }